export enum CategoryColor {
  Stock = 'stock',
  Fii = 'fii',
  Etf = 'etf',
  Bdr = 'bdr',
  Others = 'other'
}
